module.exports = __webpack_public_path__ + "static/profile-2-cb014316456ddc1cc7212239d171f1ac.jpg";